/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Warehouse_Position_NameInputs */

const vi_warehouse_position_name = /** @type {(inputs: Warehouse_Position_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tên gợi nhớ`)
};

/**

* @param {Warehouse_Position_NameInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const warehouse_position_name = /** @type {((inputs?: Warehouse_Position_NameInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Warehouse_Position_NameInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_warehouse_position_name(inputs)
});